<template>
  <div id="levelhistorylog">
    <div class="search">
      <div class="search-item">
        <span class="lable">能力类型</span>
        <el-select v-model="optionsVal" placeholder="请选择" size="mini">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <el-table
      :data="compuTableList"
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="时间"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="sj"
        label="事件"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="nl"
        label="能力"
      >
      </el-table-column>
      <el-table-column
        prop="pf"
        label="评分"
      >
      </el-table-column>
      <el-table-column
        prop="avg"
        label="平均分"
      >
      </el-table-column>
      <el-table-column
        prop="start"
        label="星级"
      >
      </el-table-column>
      <el-table-column
        prop="zc"
        label="职称事件"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref, getCurrentInstance, inject } from '@vue/composition-api'
export default {
  name: 'Levelhistorylog',
  props: [
  ],
  setup (props, ctx) {
    const vm = getCurrentInstance()
    let userId = null
    let options = [
      {
        label: '全部',
        value: ''
      },
      {
        label: '思考能力',
        value: 's01'
      },
      {
        label: '创新改进',
        value: 's02'
      },
      {
        label: '企业家精神',
        value: 's03'
      },
      {
        label: '诚信正直',
        value: 's04'
      },
      {
        label: '执行力',
        value: 's05'
      },
      {
        label: '目标管理',
        value: 's06'
      },
      {
        label: '规划能力',
        value: 's07'
      },
      {
        label: '培养人才',
        value: 's08'
      },
      {
        label: '领导力',
        value: 's09'
      }
    ]
    let optionsVal = ref('')
    let dataLog = ref([
      // {
      //   date: '2020-07-03',
      //   sj: '领导能力优秀',
      //   nl: '领导能力',
      //   pf: 4,
      //   avg: 4.5,
      //   start: '⭐⭐',
      //   code: 'ldl'
      // }, {
      //   date: '2020-07-03',
      //   sj: '规划能力优秀',
      //   nl: '规划力',
      //   pf: 3,
      //   avg: 2.5,
      //   start: '⭐⭐⭐',
      //   code: 'ghl'
      // }, {
      //   date: '2020-07-03',
      //   sj: '自驱能力优秀',
      //   nl: '自驱力',
      //   pf: 5,
      //   avg: 4.5,
      //   start: '⭐⭐⭐⭐',
      //   zc: '晋升为T4',
      //   code: 'zql'
      // }, {
      //   date: '2020-07-03',
      //   sj: '管理能力优秀',
      //   nl: '领导能力',
      //   pf: 1,
      //   avg: 1.5,
      //   start: '⭐',
      //   code: 'ldl'
      // }, {
      //   date: '2020-07-03',
      //   sj: '创新能力优秀',
      //   nl: '创新力',
      //   pf: 2,
      //   avg: 2.5,
      //   start: '⭐⭐',
      //   zc: '降级为T3',
      //   code: 'ldl'
      // }, {
      //   date: '2020-07-03',
      //   sj: '领导管理能力优秀',
      //   nl: '领导能力',
      //   pf: 4,
      //   avg: 4.5,
      //   start: '⭐⭐⭐⭐',
      //   code: 'ldl'
      // }, {
      //   date: '2020-07-03',
      //   sj: '逻辑能力优秀',
      //   nl: '逻辑能力',
      //   pf: 3,
      //   avg: 3.5,
      //   start: '⭐⭐⭐',
      //   code: 'ldl'
      // }
    ])
    let compuTableList = computed(() => {
      if (optionsVal.value === '') { return dataLog.value }
      let result = dataLog.value.filter((v) => {
        return v.code === optionsVal.value
      })
      return result
    })
    onMounted(() => {
      userId = inject('userId')
      console.log(props.userid)
      getJobHistory()
    })
    function getJobHistory () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/user/job/history',
        params: {
          userId: userId
        }
      }).then(res => {
        console.log(res)
        dataLog.value = (res ?? []).map(v => {
          let { createTime, rating, abilityLevel, eventName, jobEventName, abilityName, aveRating, abilityCode } = v
          let startCount = ''
          console.log(1)
          return {
            date: createTime,
            start: startCount.padStart(+abilityLevel, '⭐'),
            avg: aveRating,
            sj: eventName,
            nl: abilityName,
            zc: jobEventName,
            code: abilityCode,
            pf: rating
          }
        })
      })
    }
    return {
      dataLog,
      options,
      optionsVal,
      compuTableList
    }
  }
}
</script>

<style scoped lang="stylus">
.search-item
  display flex
  align-items center
  font-size 14px
  .lable
    margin-right: 10px
</style>
